import { IonCol } from "@ionic/react";
import React, { FC } from "react";

interface IProps {};

const RecentActivityCol:FC<IProps> = (props) => {
    return <IonCol className="grey-border-2pt w-100 bg-white" style={{marginBottom:'1rem', borderRadius:'1rem', padding:'1rem'}}>
                <div className="w-100 text-dark-blue font-helvetica font-med font-18pt" style={{borderBottom:'2pt solid #F1F3F6'}} > Recent Activity</div>
            </IonCol>
};

export default RecentActivityCol;